import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Crown, X } from "lucide-react";

const SEEN_KEY = "mx_elite_invite_seen";

export const eliteInviteSeen = () => {
  try { return !!localStorage.getItem(SEEN_KEY); } catch (e) { return true; }
};

// Optional, dismissible Molecularix Elite invitation shown once, right after a successful attestation.
export default function EliteInvite({ onClose }) {
  const [open, setOpen] = useState(true);
  const dismiss = () => {
    try { localStorage.setItem(SEEN_KEY, new Date().toISOString()); } catch (e) { /* ignore */ }
    setOpen(false);
    onClose?.();
  };
  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, delay: 0.6 }}
          className="fixed bottom-4 right-4 left-4 sm:left-auto sm:w-[360px] z-40 border border-[#D4AF37]/40 bg-[#0C0C0C]/95 backdrop-blur p-5"
          data-testid="elite-invite">
          <button onClick={dismiss} aria-label="Dismiss invitation" data-testid="elite-invite-dismiss"
            className="absolute top-3 right-3 text-[#52525B] hover:text-white transition-colors"><X size={16} /></button>
          <div className="flex items-start gap-3">
            <Crown size={18} className="text-[#D4AF37] mt-0.5 shrink-0" />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-1.5">Molecularix Elite</p>
              <p className="text-sm text-[#A1A1AA] leading-relaxed mb-3">
                Have an audience in the research space? Apply to our ambassador program — your followers save, you earn commission on referred orders.
              </p>
              <div className="flex items-center gap-4">
                <Link to="/ambassador" onClick={dismiss} data-testid="elite-invite-link"
                  className="font-mono text-[10px] uppercase tracking-[0.2em] text-black bg-[#D4AF37] px-4 py-2 hover:bg-[#c9a432] transition-colors">
                  Learn more
                </Link>
                <button onClick={dismiss} data-testid="elite-invite-later"
                  className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#52525B] hover:text-white transition-colors">
                  Maybe later
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
